import "vue-app/utils/pubSubInitializer";
import { ReactNativeBridge } from "vue-app/utils/reactNativeBridge";
new ReactNativeBridge({ withRegistry: false });
import "../assets/scss/main.css";
import { usePostHog } from "vue-app/composables/usePostHog";
import { createApp } from "vue";
import PageLogin from "../pages/PageLogin/PageLogin.vue";
import TranslatePlugin from "../plugins/edroneTranslate/edroneTranslatePlugin";
import "./icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "../thirdParty/hotjar";
import "../thirdParty/intercomInitScript";

if (document.querySelector("#login")) {
  const app = createApp(PageLogin);
  app.use(TranslatePlugin);
  app.component("font-awesome-icon", FontAwesomeIcon);
  app.mount("#login");
  usePostHog();
}
